import React from 'react';
import { isNotSpaceOrEnterKey } from '../../common/utils/accessibilityGenericMessage';
import { useTranslation } from 'react-i18next';
import { TaskItem } from '../../taskList/interfaces';

export interface RRMessageLabelProps {
  onRRMsgBtnClick?: (showPopup: boolean, currentItem?: TaskItem) => void;
  item: TaskItem;
  className: string;
}

const RRMessageLabel = (props: RRMessageLabelProps): JSX.Element => {
  const { onRRMsgBtnClick, item, className } = props;

  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation();
    onRRMsgBtnClick && onRRMsgBtnClick(true, item);
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (isNotSpaceOrEnterKey(e)) return;
    e.stopPropagation();
    onRRMsgBtnClick && onRRMsgBtnClick(true, item);
  };

  return (
    <span
      role="button"
      tabIndex={0}
      data-testid="rr-label"
      color="inherit"
      className={className}
      onClick={handleClick}
      onKeyDown={handleKeyDown}>
      <strong>{t('rrLabel')}</strong>
    </span>
  );
};

export default RRMessageLabel;
